import * as Yup from 'yup'

export const ValidateSchemaCreate = Yup.object().shape({
    name: Yup.string()
        .required('Название является обязательным')
        .min(3, 'Название должно содержать минимум 3 символа')
        .max(100, 'Название не должно превышать 100 символов'),
    price: Yup.number()
        .typeError('Введите корректную цену')
        .required('Цена является обязательной')
        .min(1, 'Цена должна быть больше 0'),
    total_count: Yup.number()
        .typeError('Введите корректное количество')
        .required('Количество является обязательным')
        .min(1, 'Количество должно быть не меньше 1'),
})
